import React from 'react';
import SuggestedPanel from '../../../LandingPage/SuggestedPanel';
import SectionContainer from '../SectionContainer';

/**
 * Section component for the SuggestedPanel
 * This allows the SuggestedPanel to be used within the PageBuilder system
 * 
 * @component
 * @param {Object} props
 * @param {string} props.sectionId - ID of the section
 * @param {string} [props.className] - Custom class name
 * @param {string} [props.rootClassName] - Root class name override
 * @param {Array} [props.suggestedListings] - Array of listings to display
 * @param {number} [props.visibleCards] - Number of visible cards (default: 6)
 * @param {boolean} [props.usePlaceholders] - Whether to use placeholder data
 * @param {Object} [props.appearance] - Appearance configuration
 * @param {Object} [props.options] - Additional options
 * @returns {JSX.Element} Section containing SuggestedPanel
 */
const SectionSuggested = props => {
  const {
    sectionId,
    className,
    rootClassName,
    suggestedListings = [],
    visibleCards = 6,
    usePlaceholders = true,
    appearance,
    options,
    // Extract React-specific props that don't need to be passed down
    defaultClasses,
    isInsideContainer,
    sectionType,
    sectionName,
    // Any remaining props that might be valid DOM attributes
    ...domProps
  } = props;

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={options}
      {...domProps}
    >
      <SuggestedPanel
        listings={suggestedListings}
        visibleCards={visibleCards}
        usePlaceholders={usePlaceholders}
      />
    </SectionContainer>
  );
};

export default SectionSuggested;